import axios from 'axios';
import AuthManager from '../managers/AuthManager';

const authManager = new AuthManager();

const matchLoginLogoutPath = (record) => {
  return (
    (record.path === '/:namespace/login') ||
    (record.path === '/:namespace/forgot')
  );
};

let currentNamespace = null;

const guard = (to, from, next) => {
  if (currentNamespace && currentNamespace !== to.params.namespace) {
    // change team force reload
    window.location.reload(to, true);
    return;
  }
  currentNamespace = to.params.namespace;

  if (to.matched.some(record => record.meta.requiresAuth)) {
    // check user in namespace is logged in or not
    authManager.checkAuth(to.params.namespace).then((credential) => {
      // set authorization header
      axios.defaults.headers.common.Authorization = `Bearer ${credential.access_token}`;
      return next();
    })
    .catch(() => {
      // user doesn't login redirect to login page
      return next(`/${to.params.namespace}/login`);
    });
  } else if (to.matched.some(matchLoginLogoutPath)) {
    // check /:namespace/login and /:namespace/forgot
    authManager.checkAuth(to.params.namespace).then((credential) => {
      // set authorization header
      axios.defaults.headers.common.Authorization = `Bearer ${credential.access_token}`;

      if (Object.keys(to.query).length <= 0) {
        // redirect to team dashboard page
        return next(`/${to.params.namespace}/`);
      } else {
        return next();
      }
    })
    .catch(() => {
      return next();
    });
  } else {
    next();
  }
};

export default guard;



// WEBPACK FOOTER //
// ./src/router/guard.js